import api from "../../config/client.axios.api";
import { TResetPassword } from "../../types";

export const resetPasswordApiRequest = async (dataRequest: TResetPassword) => {
  const response = await api.post(`/auth/reset-password`, dataRequest);
  return response.data;
};
